import { useEffect, useMemo, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import LandingModal from "../components/joinLandingModal/LandingModal.jsx";

const JoinEventRedirect = () => {
  const { id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();

  const isJoinUsher = location.pathname.includes("/joinUsher");

  const paramName = isJoinUsher ? "usherCode" : "invitecode";
  const role = isJoinUsher ? "usher" : "guest";

  const code = useMemo(() => {
    const params = new URLSearchParams(location.search);
    return params.get(paramName);
  }, [location.search, paramName]);

  const isMobile = useMemo(
    () => /Android|iPhone|iPad|iPod/i.test(navigator.userAgent),
    []
  );

  const shouldShowModal = Boolean(isMobile && id && code);

  useEffect(() => {
    if (!id || !code) return;
    if (!isMobile) {
      navigate(`/${isJoinUsher ? "join-Usher" : "join-Event"}/${id}/${code}`, {
        state: { role },
        replace: true,
      });
      return;
    }
  }, [id, code, isMobile, navigate, isJoinUsher]);
  
  const handleOpenApp = () => {
    const deepLink = `${process.env.REACT_APP_NODE_API}/${
      isJoinUsher ? "joinUsher" : "joinEvent"
    }/${id}?${paramName}=${code}`;

    const appLink = `nimblebash://${
      isJoinUsher ? "joinUsher" : "joinEvent"
    }/${id}?${paramName}=${code}`;

    const storeLink = /iPhone|iPad|iPod/i.test(navigator.userAgent)
      ? "https://apps.apple.com/ng/app/nimblebash/id6752389351"
      : "https://play.google.com/store/apps/details?id=com.nimblebash.nimblebyte";


    let appOpened = false;

    const onVisibilityChange = () => {
      if (document.hidden) {
        appOpened = true;
        document.removeEventListener("visibilitychange", onVisibilityChange);
      }
    };

    document.addEventListener("visibilitychange", onVisibilityChange);

    window.location.href = appLink;

    setTimeout(() => {
      document.removeEventListener("visibilitychange", onVisibilityChange);
      if (!appOpened) {
        window.location.href = storeLink;
      }
    }, 1500);
  };

  const handleContinueWeb = () => {
    navigate(`/${isJoinUsher ? "join-Usher" : "join-Event"}/${id}/${code}`, {
      replace: true,
      state: { role },
    });
  };

  return (
    <>
      <p style={{ textAlign: "center", marginTop: 40 }}>
        Preparing your event...
      </p>

      {shouldShowModal && (
        <LandingModal
          title="Open in NimbleBash App?"
          description="For best experience, open this event in the NimbleBash mobile app."
          onOpenApp={handleOpenApp}
          onContinueWeb={handleContinueWeb}
        />
      )}
    </>
  );
};

export default JoinEventRedirect;
